import './css/components/content.scss';

/*
import 'bootstrap-modal-js';
import 'bootstrap-toast-js';
import 'bootstrap-tab-js';
import 'bootstrap-collapse-js';
import 'bootstrap-dropdown-js';
*/

import "./js/utils/defer.js";

import notifyMessage from "./js/components/notify";

$.lukkariNotify = notifyMessage;

import SvgImagesToInline from "./js/utils/svg-images-to-inline";
import SocialMediaShareButtons from "./js/components/social-media-share-buttons";
import "./js/utils/defer.js";
import OffcanvasMenu from "./js/components/offcanvas-navigation";
import "./js/components/scope-selector";
import "./js/components/smoothscrollinghashes";
import "./js/components/copy-link";
import "./js/components/mail";
import "./js/components/social-media-controller";
import "./js/components/cookie-consent";
import "./js/components/user-questionnaire";
import "./js/components/iframes";

import "./js/accordion";
//import "./js/additional-methods";
import "./js/constituency-association-search";

import handlePagination from "./js/components/pagination";

document.addEventListener("DOMContentLoaded", () => {
  if ($(".input__datepicker").length) {
    $(".input__datepicker").datepicker();
  }
  if ($(".input__timepicker").length) {
    $(".input__timepicker").timepicker();
  }

  if (typeof SocialMediaShareButtons !== "undefined") {
    SocialMediaShareButtons(".some-share__placeholder");
  }

  if (typeof SvgImagesToInline !== "undefined") {
    SvgImagesToInline("img.svg-to-inline");
    window.SvgImagesToInline = SvgImagesToInline;
  }

  $("table.tablesorter").tablesorter();
  $("table.table.floating-heading").floatThead();

  handlePagination(".pagination--clean");

  $(
    ".content-porlet a, .event-description a, .news-item-article-page a, .glossary-section a, .journal-content-article a, .portlet-ambnews-article a"
  )
    .filter(function () {
      if ($(this).hasClass("share-icon")) {
        return false;
      }

      if ($(this).hasClass("cta")) {
        $(this).attr({
          target: "_blank",
          title: externalSite,
        });
        return false;
      }

      if (this.hostname) {
        var hostname = normalize(this.hostname);
        var locationHostname = normalize(location.hostname);

        if (
          $(this).attr("href") &&
          $(this).attr("href").toLowerCase().endsWith(".pdf")
        ) {
          $(this).addClass("ext-pdf").attr("target", "_blank");
        }

        return hostname !== locationHostname;
      }
    })
    .addClass("ext-link")
    .attr({
      target: "_blank",
      title: externalSite,
    });

  function normalize(hostname) {
    hostname = hostname.replace("https://", "");
    hostname = hostname.replace("http://", "");
    hostname = hostname.replace("www.", "");

    return hostname;
  }
});

import "./css/index.scss";
import "./css/lukkari-srk/main.scss";
